import { AutoSaveIndicator, Button, Css, useModal } from "@homebound/beam";
import { ReadyPlanVersionHeader } from "src/components/ReadyPlanVersionHeader";
import { PageHeader } from "src/routes/layout/PageHeader";
import { PlanPackageTakeoffPage_TakeoffDetailFragment } from "src/routes/libraries/plan-package/takeoffs/PlanPackageTakeoffPage.generated";
import { fail } from "src/utils";
import { PublishAggregateVersionModal } from "../../details/components/PublishAggregateVersionModal";

export type TakeoffHeaderProps = { planPackage: PlanPackageTakeoffPage_TakeoffDetailFragment };

export function TakeoffsHeader({ planPackage }: TakeoffHeaderProps) {
  const { openModal } = useModal();
  const { aggregateDraft, name } = planPackage;

  return (
    <PageHeader
      xss={Css.bgTransparent.bn.mb0.$}
      titleSize="xl2"
      title="Takeoff Manager"
      left={<AutoSaveIndicator />}
      right={
        <>
          <ReadyPlanVersionHeader readyPlan={planPackage} versionId={planPackage.version?.id} />
          {/* TODO: Work with Product & Design to determine when/how this can be Published */}
          <Button
            size="md"
            disabled={!aggregateDraft?.canPublish.allowed}
            tooltip={aggregateDraft?.canPublish.disabledReasons.map((reason) => reason.message).join(", ")}
            label="Publish"
            onClick={() =>
              openModal({
                content: (
                  <PublishAggregateVersionModal
                    draftAggregateVersion={aggregateDraft ?? fail("No draft aggregate version found")}
                    copyText="This update will be made available to any Design Package and Product Offering that reference it."
                    readyPlanName={name}
                  />
                ),
              })
            }
          />
        </>
      }
    />
  );
}
